import React from 'react'
import { DateTimeInput } from 'react-admin'

export const TopDateTimeFilter = [
  <DateTimeInput label="начиная с" source="last_seen_gte" alwaysOn />,
  <DateTimeInput label="заканчивая по" source="last_seen_lte" alwaysOn />,
]
